import type { DeepRequired } from '../fixtures.types'

const getProviderStatements: DeepRequired<GetProviderStatementsResponse> = {
  __typename: 'GetProviderStatementsResponse',
  statements: [],
  nextPage: null,
}

export default getProviderStatements
